import tunnel from 'tunnel-rat';

export const three = tunnel();
export const ui = tunnel();
export const grid = tunnel();
export const tags = tunnel();
